import { Box, IconButton } from "@mui/material";
import { Icon } from "@iconify/react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { convertCamelCaseToDisplayText } from "../../utils";
import { monthOptions } from "../../pages/oem/training/training-report/helper";
import moment from "moment";
export const HeaderConfig = [
  {
    label: "User Name",
    id: "name",
    render: (data) => {
      return <span>{data?.user?.name}</span>;
    },
  },
  {
    label: "Type",
    id: "type",
    render: (data) => {
      return (
        <span>
          {data?.type === "MONTH" ? "Monthly Performer" : "Yearly Performer"}
        </span>
      );
    },
  },
  {
    label: "Month",
    id: "month",
    render: (data) => {
      return <span>{data?.month}</span>;
    },
  },
  {
    label: "Year",
    id: "year",
    render: (data) => {
      return <span>{data?.year}</span>;
    },
  },
  {
    label: "Created on",
    id: "createdAt",
    render: (data) => (
      <span>
        {data.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}
      </span>
    ),
  },

  {
    label: "Action",
    id: "action",
    render: (data, onClick) => (
      <Box sx={{ display: "flex" }}>
        <IconButton onClick={() => onClick("EDIT", data)} sx={{ p: 0 }}>
          <EditIcon color="primary" />
        </IconButton>
        <IconButton onClick={() => onClick("DELETE", data)} sx={{ p: 0 }}>
          <DeleteIcon color="error" />
        </IconButton>
      </Box>
    ),
  },
];
export const PERFORMER_TYPE = [
  { label: "Monthly", value: "MONTH" },
  { label: "Yearly", value: "YEAR" },
];
export function generateYearList(startYear = 2020, endYear = 2100) {
  const yearList = [];
  for (let year = startYear; year <= endYear; year++) {
    yearList.push({
      value: year.toString(),
      label: year.toString(),
    });
  }
  return yearList;
}

export const getUserFormConfig = (usersList) => {
  const list = [
    {
      name: "user",
      type: "autocomplete",
      label: "User",
      options: usersList,
      placeholder: "Select User",
      required: true,
    },
    {
      name: "type",
      type: "autocomplete",
      label: "Performer Type",
      options: PERFORMER_TYPE,
      placeholder: "Type",
      required: true,
    },
    {
      name: "month",
      type: "autocomplete",
      label: "Month",
      options: monthOptions,
      placeholder: "Select Month",
    },
    {
      name: "year",
      type: "autocomplete",
      label: "Year",
      options: generateYearList(2020, 2100),
      placeholder: "Select Year",
      required: true,
    },
    {
      name: "description",
      type: "text",
      label: "Description",
      placeholder: "Description",
    },
  ];

  return list;
};
